module.exports = __webpack_public_path__ + "static/media/psga_new.1c0c5f1b.png";